import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import AdminLayout from './components/layout/AdminLayout';
import Dashboard from './components/Dashboard';
import CardsTable from './components/CardsTable';
import CardDetail from './components/CardDetail';
import RewardsV1Table from './components/RewardsV1Table';
import RewardsV1Detail from './components/RewardsV1Detail';
import RewardDetail from './components/RewardDetail';
import CategoriesTable from './components/CategoriesTable';
import CategoryDetail from './components/CategoryDetail';
import MilestonesTable from './components/MilestonesTable';
import MilestoneDetail from './components/MilestoneDetail';
import UsersTable from './components/UsersTable';
import UserCardsTable from './components/UserCardsTable';
import AnalyticsCards from './components/AnalyticsCards';
import ExpensesTable from './components/ExpensesTable';
import ExpenseDetail from './components/ExpenseDetail';
import AllQuestions from './components/AllQuestions';
import RecommendedCardDetail from './components/RecommendedCardDetail';
import ExpenseRewardSearch from './components/ExpenseRewardSearch';
import RewardOptionDetailV1 from './components/RewardOptionDetailV1';
import TripsTable from './components/TripsTable';
import TripDetail from './components/TripDetail';
import TripRequestsTable from './components/TripRequestsTable';
import TripRequestDetail from './components/TripRequestDetail';
import ExpenseRequestsTable from './components/ExpenseRequestsTable';
import ExpenseRequestDetail from './components/ExpenseRequestDetail';
import CommunityPostsTable from './components/CommunityPostsTable';
import CommunityPostDetail from './components/CommunityPostDetail';
import PendingCommunityPostsTable from './components/PendingCommunityPostsTable';
import ShowcaseCommunityPostsTable from './components/ShowcaseCommunityPostsTable';
import CommentsTable from './components/CommentsTable';
import CommentDetail from './components/CommentDetail';
import RewardLogsTable from './components/RewardLogsTable';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import NotFound from './components/NotFound';
import GmailCallback from './components/GmailCallback';
import Settings from './components/Settings';
import BlogsTable from './components/BlogsTable';
import BlogEditor from './components/BlogEditor';
import RewardsV1Edit from './components/RewardsV1Edit';
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <Router>
      <div className="App">
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/404" element={<NotFound />} />
            <Route element={<ProtectedRoute />}> 
              <Route element={<AdminLayout />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/cards" element={<CardsTable />} />
                <Route path="/cards/:id" element={<CardDetail />} />
                <Route path="/rewards" element={<RewardsV1Table />} />
                <Route path="/rewards/json-edit/:id" element={<RewardsV1Detail />} />
                <Route path="/rewards/edit/:id" element={<RewardsV1Edit />} />
                <Route path="/rewards/new/:id" element={<RewardsV1Edit />} />
                <Route path="/rewards-legacy/:id" element={<RewardDetail />} />
                <Route path="/milestones" element={<MilestonesTable />} />
                <Route path="/milestones/:id" element={<MilestoneDetail />} />
                <Route path="/categories" element={<CategoriesTable />} />
                <Route path="/categories/:slug" element={<CategoryDetail />} />
                <Route path="/banks" element={<div className="text-center py-12"><h2 className="text-xl font-semibold text-gray-900">Banks Management</h2><p className="mt-2 text-gray-500">Coming soon...</p></div>} />
                <Route path="/analytics" element={<Navigate to="/analytics/cards" replace />} />
                <Route path="/analytics/cards" element={<AnalyticsCards />} />
                <Route path="/users" element={<UsersTable />} />
                <Route path="/user-cards" element={<UserCardsTable />} />
                <Route path="/expenses" element={<ExpensesTable />} />
                <Route path="/expenses/questions" element={<AllQuestions />} />
                <Route path="/expenses/rewards" element={<ExpenseRewardSearch />} />
                <Route path="/expenses/requests" element={<ExpenseRequestsTable />} />
                <Route path="/expenses/requests/:id" element={<ExpenseRequestDetail />} />
                <Route path="/expenses/:userId" element={<ExpenseDetail />} />
                <Route path="/expenses/:userId/rewards" element={<ExpenseRewardSearch />} />
                <Route path="/reward-logs" element={<RewardLogsTable />} />
                <Route path="/trips" element={<TripsTable />} />
                <Route path="/trips/requests" element={<TripRequestsTable />} />
                <Route path="/trips/requests/:id" element={<TripRequestDetail />} />
                <Route path="/trips/:id" element={<TripDetail />} />
                <Route path="/community" element={<CommunityPostsTable />} />
                <Route path="/community/pending" element={<PendingCommunityPostsTable />} />
                <Route path="/community/showcase" element={<ShowcaseCommunityPostsTable />} />
                <Route path="/community/:id" element={<CommunityPostDetail />} />
                <Route path="/comments" element={<CommentsTable />} />
                <Route path="/comments/:id" element={<CommentDetail />} />
                <Route path="/blogs" element={<BlogsTable />} />
                <Route path="/blogs/new" element={<BlogEditor />} />
                <Route path="/blogs/:id" element={<BlogEditor />} />
                <Route path="/rewardsv1/option-detail" element={<RewardOptionDetailV1 />} />
                <Route path="/cards/recommended" element={<RecommendedCardDetail />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/gmail/callback" element={<GmailCallback />} />
              </Route>
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </div>
    </Router>
  );
}

export default App;
